var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.44141 14.1768L10.1189 14.1643L18.1456 6.21435C18.4606 5.89935 18.6339 5.48102 18.6339 5.03602C18.6339 4.59102 18.4606 4.17268 18.1456 3.85768L16.8239 2.53602C16.1939 1.90602 15.0947 1.90935 14.4697 2.53352L6.44141 10.4852V14.1768ZM15.6456 3.71435L16.9697 5.03352L15.6389 6.35185L14.3172 5.03102L15.6456 3.71435ZM8.10807 11.1802L13.1331 6.20268L14.4547 7.52435L9.43057 12.5002L8.10807 12.5043V11.1802Z",
    fill: "#5B5B5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77604 17.5H16.4427C17.3619 17.5 18.1094 16.7525 18.1094 15.8333V8.61L16.4427 10.2767V15.8333H7.40771C7.38604 15.8333 7.36354 15.8417 7.34188 15.8417C7.31438 15.8417 7.28687 15.8342 7.25854 15.8333H4.77604V4.16667H10.4819L12.1485 2.5H4.77604C3.85687 2.5 3.10938 3.2475 3.10938 4.16667V15.8333C3.10938 16.7525 3.85687 17.5 4.77604 17.5Z",
    fill: "#5B5B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0b86a2385bf42a70f3e4065bf70505b5.svg";
export { ForwardRef as ReactComponent };